// userSelectors.js
import { atom, selector } from 'recoil';
import { persistAtom } from 'recoil-persist';
// completed event array images
export const events = atom({
  key: 'events', 
  default: [], 
  effects_UNSTABLE: [
    ({ setSelf, onSet }) => {
      const savedValue = sessionStorage.getItem('Events');
      if (savedValue != null) {
        setSelf(JSON.parse(savedValue));
      }
      onSet((newValue) => {
        sessionStorage.setItem('Events', JSON.stringify(newValue));
      });
    },
  ],
});

export const ActiveEvents = selector({
  key: 'ActiveEvents',
  get: ({ get }) => {
    const value = get(events);
    return value;
  },
  set: ({ set }, newValue) => {
    set(events, newValue);
  },
});

// page level index
export const defaultDetails = atom({
  key: 'defaultDetails', 
  default: {currentIndex: 0,selectedEID: ''}, 
  effects_UNSTABLE: [
    ({ setSelf, onSet }) => {
      const savedValue = sessionStorage.getItem('defaultDetails');
      if (savedValue != null) {
        setSelf(JSON.parse(savedValue));
      }
      onSet((newValue) => {
        sessionStorage.setItem('defaultDetails', JSON.stringify(newValue));
      });
    },
  ],
});

export const pageDetails = selector({
  key: 'pageDetails',
  get: ({ get }) => {
    const value = get(defaultDetails);
    return value;
  },
  set: ({ set }, newValue) => {
    set(defaultDetails, newValue);
  },
});

export const userSession = selector({
  key: 'userSession',
  get: ({ get }) => {
    const value = get(defaultSession);
    console.log(value)
    return value;
  },
  set: ({ set }, newValue) => {
    set(defaultSession, newValue);
  },
});

export const defaultSession = atom({
  key: 'defaultSession', 
  default: {showPopup: null}, 
  effects_UNSTABLE: [
    ({ setSelf, onSet }) => {
      const savedValue = sessionStorage.getItem('defaultSession');
      if (savedValue != null) {
        setSelf(JSON.parse(savedValue));
      }
      onSet((newValue) => {
        sessionStorage.setItem('defaultSession', JSON.stringify(newValue));
      });
    },
  ],
});

export const toaster = selector({
  key: 'toaster',
  get: ({ get }) => {
    const value = get(defaultToaster);
    return value;
  },
  set: ({ set }, newValue) => {
    set(defaultToaster, newValue);
  },
});

export const defaultToaster = atom({
  key: 'defaultToaster', 
  default: {showPopup: false, message:'', type:'success'}, 
  effects_UNSTABLE: [
    ({ setSelf, onSet }) => {
      const savedValue = sessionStorage.getItem('defaultToaster');
      if (savedValue != null) {
        setSelf(JSON.parse(savedValue));
      }
      onSet((newValue) => {
        sessionStorage.setItem('defaultToaster', JSON.stringify(newValue));
      });
    },
  ],
});

export const newEvent = selector({
  key: 'newEvent',
  get: ({ get }) => {
    const value = get(defaultEvent);
    return value.evt;
  },
  set: ({ set }, newValue) => {
    set(defaultEvent, newValue);
  },
});

export const defaultEvent = atom({
  key: 'defaultEvent', 
  default: {evt: null}, 
  effects_UNSTABLE: [
    ({ setSelf, onSet }) => {
      const savedValue = sessionStorage.getItem('defaultEvent');
      if (savedValue != null) {
        setSelf(JSON.parse(savedValue));
      }
      onSet((newValue) => {
        sessionStorage.setItem('defaultEvent', JSON.stringify(newValue));
      });
    },
  ],
});





